import _ from 'lodash';

export const CATALOG_KEYS = [
  'products',
  'productLayouts',
  'wallSpace',
  'interior',
  'requireDoors',
  'panels',
  'panel1',
  'panel2',
  'panel3',
  'panel4',
  'frames',
  'endPanelFinish',
  'hardware',
  'boards',
  'tops',
  'depths',
  'drawerTypes',
  'addRails',
  'addShelves',
  'hingedHeights',
  'hingedDoors',
  'corniceHeights',
  'delivery',
  'benchCutouts',
  'requireHandles',
  'handles',
  'requireDesignAppointment',
  'preferredContactMethod',
  'requireDesignModifications',
  'modifications',
  'timeline',
  'config',
  'configGroup',
  'doorProfile',
  'panelFinish',
  'benchtopMaterial',
  'panelTypes',
  'components',
  'features',
  'description'
];

export function catalogOptions(catalog) {
  if (!_.isUndefined(catalog) && !_.isUndefined(catalog.options)) return catalog.options;
  return [];
}

export function emptyCatalog() {
  return CATALOG_KEYS.reduce((catalog, key) => {
    catalog[key] = {};
    return catalog;
  }, {});
}

export function catalogGetters() {
  return CATALOG_KEYS.reduce((getters, key) => {
    getters[key] = (state) => state.catalog[key];
    return getters;
  }, {});
}

// Getter name -> catalog key for simple `builder.fooOptions` wrappers.
export const CATALOG_OPTIONS_GETTERS = {
  wallSpaceOptions: 'wallSpace',
  requireDoorsOptions: 'requireDoors',
  framesOptions: 'frames',
  hardwareOptions: 'hardware',
  boardsOptions: 'boards',
  hingedTopsOptions: 'tops',
  depthsOptions: 'depths',
  drawerTypesOptions: 'drawerTypes',
  hingedHeightsOptions: 'hingedHeights',
  corniceHeightsOptions: 'corniceHeights',
  addRailsOptions: 'addRails',
  addShelvesOptions: 'addShelves',
  benchCutoutsOptions: 'benchCutouts',
  requireHandlesOptions: 'requireHandles',
  requireDesignAppointmentOptions: 'requireDesignAppointment',
  preferredContactMethodOptions: 'preferredContactMethod',
  requireDesignModificationsOptions: 'requireDesignModifications',
  timelineOptions: 'timeline',
  configOptions: 'config'
};

export function catalogOptionsGetters() {
  return Object.entries(CATALOG_OPTIONS_GETTERS).reduce((getters, [getterName, catalogKey]) => {
    getters[getterName] = (state) => catalogOptions(state.catalog[catalogKey]);
    return getters;
  }, {});
}

export function applyCatalogOpts(catalog, opts) {
  if (_.isEmpty(opts)) return catalog;

  CATALOG_KEYS.forEach((key) => {
    if (_.isUndefined(opts[key])) return;
    if (key === 'productLayouts' && _.isUndefined(opts.productLayouts.options)) return;
    catalog[key] = opts[key];
  });

  return catalog;
}
